import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardService } from '../../services/dashboardService';

// Async thunks
export const fetchDashboardStatistics = createAsyncThunk(
  'dashboard/fetchStatistics',
  async (_, { rejectWithValue }) => {
    try {
      const statistics = await dashboardService.getStatistics();
      return statistics;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Eroare la încărcarea statisticilor');
    }
  }
);

export const fetchRecentActivity = createAsyncThunk(
  'dashboard/fetchRecentActivity',
  async (_, { rejectWithValue }) => {
    try {
      const activity = await dashboardService.getRecentActivity();
      return activity;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Eroare la încărcarea activității recente');
    }
  }
);

export const fetchAlerts = createAsyncThunk(
  'dashboard/fetchAlerts',
  async (_, { rejectWithValue }) => {
    try {
      const alerts = await dashboardService.getAlerts();
      return alerts;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Eroare la încărcarea alertelor');
    }
  }
);

const initialState = {
  statistics: null,
  recentActivity: [],
  alerts: [],
  loading: false,
  error: null,
  lastUpdated: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    refreshDashboard: (state) => {
      state.lastUpdated = new Date().toISOString();
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch statistics
      .addCase(fetchDashboardStatistics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStatistics.fulfilled, (state, action) => {
        state.loading = false;
        state.statistics = action.payload;
        state.lastUpdated = new Date().toISOString();
      })
      .addCase(fetchDashboardStatistics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch recent activity
      .addCase(fetchRecentActivity.fulfilled, (state, action) => {
        state.recentActivity = action.payload;
      })
      // Fetch alerts
      .addCase(fetchAlerts.fulfilled, (state, action) => {
        state.alerts = action.payload;
      });
  },
});

export const { clearError, refreshDashboard } = dashboardSlice.actions;
export default dashboardSlice.reducer;